import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div<{ isFetching?: boolean }>`
  margin: 17px 0 10px;
  background: ${props => props.theme.palette.general.light};
  ${props => props.isFetching && `
    cursor: wait;
    > * {
      pointer-events: none;
    }
  `}

  > div {
    width: 100%;
    max-width: ${props => props.theme.maxWidth};
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    ${bp('lg')`
      flex-direction: column;
      align-items: flex-start;
      
      > div {
        width: 100%;
        margin: 10px 0;
      }
    `}
  }
`

export const LayeredNavButton = styled.div`
  box-sizing: border-box;
  display: none;
  ${bp('lg')`
    display: block;
    order: 1;
  `}

  button {
    cursor: pointer;
    padding: 10px;
    font-size: 16px;
    line-height: 1;
    color: ${props => props.theme.palette.general.strong};
    background: ${props => props.theme.palette.general.light};
    border: 1px solid ${props => props.theme.palette.general.greyLight};
    outline: none;
  }
`

export const TotalCountContainer = styled.div`
  h2 {
    ${props => props.theme.css.heading2};
    margin: 0;
  }

  span {
    display: block;
    box-sizing: border-box;
    color: ${props => props.theme.palette.primary.alphaDark};
    font-size: 16px;
    margin-top: 4px;
    ${bp('lg')`
      order: 2;
    `}
  }
`

export const SorterContainer = styled.div`
  margin: 0 0 0 25px;
  box-sizing: border-box;
  ${bp('lg')`
    display: flex;
    justify-content: flex-end;
    order: 3;
    margin: 0;
  `}

  > div {
    width: 100%;
  }
`

export const PaginationContainer = styled.div`
  margin: 0 0 0 25px;
  box-sizing: border-box;
  ${bp('lg')`
    display: flex;
    justify-content: center;
    order: 4;
    width: 100%;
    margin: 20px 0 0;
  `}
`
